<app-vis-grid [data]="gridView" [pageSize]="pageSize" [skip]="pageSkipNo" [pageable]="true"
  (pageChange)="pageChange($event)" [selectable]="true" [kendoGridSelectBy]="'Id'" [selectedKeys]="selectedItems">
  <app-vis-grid-column field="Type" title="類別" [width]="30" i18n-title="@@Type">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div class="ellipsis-content" [title]="dataItem.Type"> {{ dataItem.Type }}</div>
    </ng-template>
  </app-vis-grid-column>
  <!-- 不可編輯的欄位 editRow 傳 null，編輯中仍以文字顯示 -->
  <app-vis-grid-editable-column [editRow]="canEditField('Code') ? editRowId : null" field="Code" title="代碼" i18n-title="@@Code" [width]="100">
    <input [(ngModel)]="editData.Code" />
  </app-vis-grid-editable-column>
  <app-vis-grid-editable-column [editRow]="canEditField('Name') ? editRowId : null" field="Name" title="名稱" [width]="100" i18n-title="@@Name">
    <input [(ngModel)]="editData.Name" />
  </app-vis-grid-editable-column>
  <app-vis-grid-editable-column [editRow]="canEditField('Name1') ? editRowId : null" field="Name1" title="備註" [width]="100" i18n-title="@@Name1">
    <input [(ngModel)]="editData.Name1" />
  </app-vis-grid-editable-column>
  <app-vis-grid-editable-column [editRow]="canEditField('Name2') ? editRowId : null" field="Name2" title="其他" [width]="100" i18n-title="@@Name2">
    <input [(ngModel)]="editData.Name2" />
  </app-vis-grid-editable-column>
  <!-- <app-vis-grid-column field="Name" title="名稱"  i18n-title="@@Name">
</app-vis-grid-column> -->
  <app-vis-grid-editable-column [editRow]="canEditField('IsEnabled') ? editRowId : null" [textCenter]="true" [width]="80" field="IsEnabled" title="是否啟用"
    style="width: 16%;" i18n-title="@@IsEnabled" class="text-center custom-m-auto">
    <ng-template let-data #viewTmp>
      {{data.IsEnabled?'是':'否'}}
    </ng-template>
    <mat-radio-group [(ngModel)]="editData.IsEnabled" class="vis-form-field" style="height: 1.33rem;">
      <mat-radio-button [value]="true">是</mat-radio-button>
      <mat-radio-button [value]="false">否</mat-radio-button>
    </mat-radio-group>
  </app-vis-grid-editable-column>
  <app-vis-grid-editable-column [editRow]="canEditField('SN') ? editRowId : null" [textCenter]="true" field="SN" title="排序" [width]="20"
    i18n-title="@@SN" style="width: 16%;">
    <input [(ngModel)]="editData.SN" />
  </app-vis-grid-editable-column>
  <app-vis-grid-command-column [width]="100" [(editRow)]="editRowId" [deletable]="true" [hideEditBtn]="!IsCanEdit"
    (edit)="editRow($event.data,$event.row)" (save)="saveRow()" class="text-center custom-m-auto"
    (delete)="deleteRow($event.data)">
  </app-vis-grid-command-column>
</app-vis-grid>

<app-system-code-add [show]="showCreate" [addSystemCode]="editData" (onClose)="closeAdd()" (onAdded)="refreshList()"></app-system-code-add>

<app-std-system-code-import [typeCode]="importTargetSystemCode" (importDone)="handleSystemImportDone()" (onClose)="handleSystemImportDone()"></app-std-system-code-import>
